module.exports = __webpack_public_path__ + "static/media/YB5M13_7.a8e0170c.jpg";